import { z } from 'zod';

export const tripTypeSchema = z.enum(['one_way', 'round_trip']);
/** the trip of the load such as `one_way` or `round_trip`
 *
 * `round_trip` means the carrier must return to the original pickup point after unloading items.
 *
 * For example, this case will mainly happen when a customer wants ship a `container` from a port or warehouse to some destination.
 *
 * So a `round_trip` will have a similar flow to the following:
 * 1. the carrier `heads` to the customer location or a specific port requested by a customer
 * 2. the carrier `pickup` the container on his flatbed truck
 * 3. the carrier `heads ` to the drop off location specified by the customer
 * 4. the carrier `unload` the items inside the container on the drop off location
 * 5. the carrier `return` the original pickup location an return the empty container to the customer
 */
export type TripType = z.infer<typeof tripTypeSchema>;

export const tripLoadTypeSchema = z.enum(['container', 'goods']);
export type TripLoadType = z.infer<typeof tripLoadTypeSchema>;
